module.exports = __webpack_public_path__ + "img/teamdoor-logo.d0ed2d8e.png";